import { Button, FormLayout } from 'components/common'
import { useState } from 'react'
import toast from 'react-hot-toast'
import {
  initiateProductUpdateCron,
  initiatePromotionUpdateCron,
} from 'utils/api/configApi'
import { ERROR_CODES } from 'utils/constants'
import { handleError } from 'utils/helpers/handleError'

const loadingTypes = {
  PRODUCT_UPDATE: 'PRODUCT_UPDATE',
  DELTA_PRODUCT_UPDATE: 'DELTA_PRODUCT_UPDATE',
  PROMOTION: 'PROMOTION',
}

const successMessage =
  'Cron trigger successful. You will be notified after completion.'

const failedMessage = 'Failed to trigger cron'

const ManualTalabatCrons = () => {
  const [loading, setLoading] = useState({
    type: loadingTypes.PRODUCT_UPDATE,
    isLoading: false,
  })

  const triggerCron = async (
    loadingType: string,
    apiFn: () => Promise<any>,
    loadingMsg: string,
  ) => {
    setLoading({ type: loadingType, isLoading: true })
    const triggerToast = toast.loading(loadingMsg)

    try {
      await apiFn()
      toast.success(successMessage, { id: triggerToast })
    } catch (error) {
      handleError(error, triggerToast, {
        default: failedMessage,
        [ERROR_CODES.FTP_ALREADY_RUNNING]:
          'FTP generation is already in progress',
      })
    } finally {
      setLoading({ type: loadingType, isLoading: false })
    }
  }

  const triggerProductUpdate = async () => {
    await triggerCron(
      loadingTypes.PRODUCT_UPDATE,
      initiateProductUpdateCron,
      'Triggering Product Update cron..',
    )
  }

  const triggerDeltaProductUpdate = async () => {
    await triggerCron(
      loadingTypes.DELTA_PRODUCT_UPDATE,
      async () => await initiateProductUpdateCron(true),
      'Triggering Delta Product Update cron..',
    )
  }

  const triggerPromotionUpdate = async () => {
    await triggerCron(
      loadingTypes.PROMOTION,
      initiatePromotionUpdateCron,
      'Triggering Promotion Update cron..',
    )
  }

  return (
    <>
      <h3 className="title mt-4">Manual crons</h3>

      <FormLayout>
        <div className="flex flex-wrap items-center gap-5">
          <Button
            buttonText="Product Update"
            size="small"
            className="w-full max-w-36 !border !py-1.5 !font-normal"
            type="button"
            variant="outline"
            onClick={triggerProductUpdate}
            disabled={loading.isLoading}
            loading={
              loading.type === loadingTypes.PRODUCT_UPDATE && loading.isLoading
            }
          />

          <Button
            buttonText="Delta Product Update"
            size="small"
            className="w-full max-w-36 !border !py-1.5 !font-normal"
            type="button"
            variant="outline"
            onClick={triggerDeltaProductUpdate}
            disabled={loading.isLoading}
            loading={
              loading.type === loadingTypes.DELTA_PRODUCT_UPDATE &&
              loading.isLoading
            }
          />

          <Button
            buttonText="Promotion Update"
            size="small"
            className="w-full max-w-36 !border !py-1.5 !font-normal"
            type="button"
            variant="outline"
            onClick={triggerPromotionUpdate}
            disabled={loading.isLoading}
            loading={
              loading.type === loadingTypes.PROMOTION && loading.isLoading
            }
          />
        </div>
      </FormLayout>
    </>
  )
}

export default ManualTalabatCrons
